import querystring from "querystring";

const API_HOST = process.env.API_HOST || process.env.REACT_APP_API_HOST;
const PATHS = {};

PATHS["account/login"] = "/public/session/login"; // post
PATHS["self/profile"] = "/self/profile"; // get

PATHS["password/request"] = "/public/password/request"; // post
PATHS["password/query"] = "/public/password/query"; // post
PATHS["password/reset"] = "/public/password/reset"; // post

PATHS["account/password"] = "/account/password"; // post
PATHS["account/list"] = "/admin/account/list"; // get
PATHS["account/create"] = "/admin/account/create"; // post
PATHS["account/detail"] = "/admin/account/:account_id/detail"; // get
PATHS["account/update"] = "/admin/account/:account_id/update"; // post
PATHS["account/delete"] = "/admin/account/:account_id/delete"; // delete
PATHS["account/student"] = "/admin/account/:account_id/student"; // post
PATHS["account/roles"] = "/admin/account/:account_id/roles"; // post
PATHS["account/stripe"] = "/admin/account/:account_id/stripe"; // get
PATHS["account/card/delete"] =
  "/admin/account/stripe/source/:objectmeta_id/delete"; // delete
PATHS["account/password/admin"] = "/admin/account/:account_id/password"; // post

PATHS["student/list"] = "/admin/student/list"; //get
PATHS["student/update"] = "/admin/student/:student_id/update"; //get
PATHS["student/image"] = "/account/student/:student_id/image/upload"; //post
PATHS["student/detail"] = "/admin/student/:student_id/detail"; //get
PATHS["student/delete"] = "/admin/student/:student_id/delete"; //get
PATHS["student/schedule"] = "/admin/student/:student_id/schedule"; //get
PATHS["student/image"] = "/admin/student/:student_id/image/upload"; //post
PATHS["student/mastery"] = "/admin/student/:student_id/mastery"; //get
PATHS["student/mastery/update"] =
  "/admin/student/:student_id/mastery/:mastery_level_id/update"; // post
PATHS["student/module"] = "/admin/student/:student_id/module"; //get
PATHS["student/routine"] = "/admin/student/:student_id/routine"; //get

PATHS["teacher/list"] = "/admin/teacher/list"; //get
PATHS["teacher/update"] = "/admin/teacher/:teacher_id/update"; //get
PATHS["teacher/image"] = "/account/teacher/:teacher_id/image/upload"; //post
PATHS["teacher/detail"] = "/admin/teacher/:teacher_id/detail"; //get
PATHS["teacher/delete"] = "/admin/teacher/:teacher_id/delete"; //del
PATHS["teacher/schedule"] = "/admin/teacher/:teacher_id/schedule"; //get
PATHS["teacher/image"] = "/admin/teacher/:teacher_id/image/upload"; //post

PATHS["privilege/list"] = "/admin/privilege/list"; // get

PATHS["inventory/list"] = "/admin/inventory/list"; // get
PATHS["inventory/item"] = "/admin/inventory/:inventory_id/item"; // post
PATHS["inventory/detail"] = "/admin/inventory/:inventory_id/detail"; // get

PATHS["item/list"] = "/admin/item/list"; // get
PATHS["item/detail"] = "/admin/item/:item_id/detail"; // get
PATHS["item/update"] = "/admin/item/:inventory_item_id/update"; // post

PATHS["wallet/list"] = "/admin/wallet/list"; // get
PATHS["wallet/detail"] = "/admin/wallet/:wallet_id/detail"; // get
PATHS["wallet/tx/list"] = "/admin/wallet/:wallet_id/wallet_tx/list"; // get
PATHS["wallet/tx/detail"] =
  "/admin/wallet/:wallet_id/wallet_tx/:wallet_tx_id/detail"; // get
PATHS["wallet/transact"] = "/admin/wallet/:wallet_id/transact"; // post

PATHS["mastery/list"] = "/admin/mastery/list"; // get
PATHS["mastery/create"] = "/admin/mastery/create"; // post
PATHS["mastery/detail"] = "/admin/mastery/:mastery_id/detail"; // get
PATHS["mastery/image"] = "/admin/mastery/:mastery_id/image/upload"; // get
PATHS["mastery/update"] = "/admin/mastery/:mastery_id/update"; // post
PATHS["mastery/delete"] = "/admin/mastery/:mastery_id/delete"; // delete
PATHS["mastery/reorder"] = "/admin/mastery/order"; // post

PATHS["item_class/list"] = "/admin/item_class/list"; // get
PATHS["item_class/create"] = "/admin/item_class/create"; // post
PATHS["item_class/detail"] = "/admin/item_class/:item_class_id/detail"; // get
PATHS["item_class/update"] = "/admin/item_class/:item_class_id/update"; // post
PATHS["item_class/delete"] = "/admin/item_class/:item_class_id/delete"; // delete

PATHS["module/create"] = "/admin/mastery/:mastery_id/module"; // post
PATHS["module/list"] = "/admin/module/list"; // get
PATHS["module/detail"] = "/admin/module/:module_id/detail"; // get
PATHS["module/update"] = "/admin/module/:module_id/update"; // post
PATHS["module/delete"] = "/admin/module/:module_id/delete"; // delete
PATHS["module/schedule"] = "/admin/module/:module_id/schedule"; //get

PATHS["routine/create"] = "/admin/module/:module_id/routine"; // post
PATHS["routine/list"] = "/admin/routine/list"; // get
PATHS["routine/detail"] = "/admin/routine/:routine_id/detail"; // get
PATHS["routine/update"] = "/admin/routine/:routine_id/update"; // post
PATHS["routine/image"] = "/admin/routine/:routine_id/image/upload"; // post
PATHS["routine/delete"] = "/admin/routine/:routine_id/delete"; // delete
PATHS["routine/visual/create"] = "/admin/routine/:routine_id/visual/create/upload"; // post
PATHS["routine/visual/list"] = "/admin/routine/:routine_id/visual/list"; // get
PATHS["routine/visual/delete"] =
  "/admin/routine/:routine_id/visual/:asset_id/delete"; // delete

PATHS["lesson/list"] = "/admin/lesson/list"; // get
PATHS["lesson/create"] = "/admin/lesson/create"; // post
PATHS["lesson/detail"] = "/admin/lesson/:lesson_id/detail"; // get
PATHS["lesson/update"] = "/admin/lesson/:lesson_id/update"; // post
PATHS["lesson/delete"] = "/admin/lesson/:lesson_id/delete"; // delete
PATHS["lesson/module"] = "/admin/lesson/:lesson_id/module"; // post
PATHS["lesson/mastery"] = "/admin/lesson/:lesson_id/mastery"; // post
PATHS["lesson/teacher"] = "/admin/lesson/:lesson_id/teacher"; // post
PATHS["lesson/slot/create"] = "/admin/lesson/:lesson_id/slot"; // post
PATHS["lesson/schedule"] = "/admin/lesson/:lesson_id/schedule"; //get

PATHS["slot/list"] = "/admin/slot/list"; // get
PATHS["slot/detail"] = "/admin/slot/:slot_id/detail"; // get
PATHS["slot/update"] = "/admin/slot/:slot_id/update"; // post
PATHS["slot/close"] = "/admin/slot/:slot_id/close"; // post
PATHS["slot/delete"] = "/admin/slot/:slot_id/delete"; // post
PATHS["slot/activity"] = "/admin/slot/:slot_id/activity/create"; // post
PATHS["slot/schedule"] = "/admin/slot/:slot_id/schedule"; //get

PATHS["wallet/list"] = "/admin/wallet/list"; // get
PATHS["wallet/detail"] = "/admin/wallet/:wallet_id/detail"; // get
PATHS["wallet/transact"] = "/admin/wallet/:wallet_id/transact"; // post

PATHS["wallet_transaction/list"] = "/admin/wallet_tx/list"; // get

PATHS["order/list"] = "/admin/order/list"; // get
PATHS["order/detail"] = "/admin/order/:order_id/detail"; // get

PATHS["payment/list"] = "/admin/order/:order_id/payment/list"; // get
PATHS["payment/detail"] = "/admin/order/:order_id/payment/payment_id/list"; // get

PATHS["transaction/list"] = "/admin/transaction/list"; // get
PATHS["transaction/detail"] = "/admin/transaction/:transaction_id/detail"; // get

PATHS["order/list"] = "/admin/order/list"; // get
PATHS["order/detail"] = "/admin/order/:order_id/detail"; // get

PATHS["product/list"] = "/admin/product/list"; // get
PATHS["product/create"] = "/admin/product/create"; // post
PATHS["product/detail"] = "/admin/product/:product_id/detail"; // get
PATHS["product/update"] = "/admin/product/:product_id/update"; // post
PATHS["product/delete"] = "/admin/product/:product_id/delete"; // delete
PATHS["product/image"] = "/admin/product/:product_id/image/upload"; // post

PATHS["booking/list"] = "/admin/booking/list"; // get
PATHS["booking/detail"] = "/admin/booking/:booking_id/detail"; // get
PATHS["booking/delete"] = "/admin/booking/:booking_id/delete"; // del
PATHS["booking/update"] = "/admin/booking/:booking_id/update"; // post
PATHS["booking/create"] = "/admin/booking/create"; // post

PATHS["pay_option/list"] = "/admin/pay_option/list"; // get
PATHS["pay_option/detail"] = "/admin/pay_option/:pay_option_id/detail"; // get
PATHS["pay_option/delete"] = "/admin/pay_option/:pay_option_id/delete"; // del
PATHS["pay_option/update"] = "/admin/pay_option/:pay_option_id/update"; // post
PATHS["pay_option/create"] = "/admin/pay_option/create"; // post

PATHS["post/list"] = "/admin/post/list"; // get
PATHS["post/create"] = "/admin/lesson/:lesson_id/slot/:lessonslot_id/post"; // post
PATHS["post/detail"] = "/admin/post/:post_id/detail"; // get
PATHS["post/update"] = "/admin/post/:post_id/update"; // post
PATHS["post/delete"] = "/admin/post/:post_id/delete"; // del

PATHS["notice/list"] = "/admin/notice/list"; // get
PATHS["notice/create"] = "/admin/notice/create"; // post
PATHS["notice/detail"] = "/admin/notice/:notice_id/detail"; // get
PATHS["notice/update"] = "/admin/notice/:notice_id/update"; // post
PATHS["notice/delete"] = "/admin/notice/:notice_id/delete"; // delete

PATHS["activity/create"] = "/admin/activity/create"; // post
PATHS["activity/list"] = "/admin/activity/list"; // get
PATHS["activity/detail"] = "/admin/activity/:activity_id/detail"; // get
PATHS["activity/update"] = "/admin/activity/:activity_id/update"; // post
PATHS["activity/delete"] = "/admin/activity/:activity_id/delete"; // delete
PATHS["activity/media/create"] = "/admin/activity/:activity_id/media/upload"; // post
PATHS["activity/media/delete"] =
  "/admin/activity/:activity_id/media/:asset_id/delete"; // delete

PATHS["misc/appversion"] = "/public/appversion";

export function get_api_path(key, query_params, route_params = {}) {
  const prefix = API_HOST;

  let url = prefix + PATHS[key];
  for (let paramKey in route_params) // eslint-disable-line
    url = url.replace(`:${paramKey}`, route_params[paramKey]);

  if (query_params) url += "?" + querystring.stringify(query_params);
  return url;
}
